import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core";
import { TripOriginOutlined } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  messageMedia: {
    cursor: "pointer",
    objectFit: "cover",
    transition: "all 0.3s",
    width: 250,
    height: 200,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },

  messageMediaFullScreen: {
    transition: "all 0.30s",
    width: 250,
    height: 200,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },

  deletedMediaMessage: {
    opacity: 0.7,
    filter: "grayscale(80%)",
  },

  spoilerSpan: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
    userSelect: "none",

    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: "2",
    cursor: "pointer",
  },

  deletedMediaSpoilerSpan: {
    opacity: 0.7,
    filter: "grayscale(80%)",
  },
}));

const ViewOnceMessage = ({ message, isPhoto, refKey = "", videoRefs = null }) => {
  //  ***************
  //  ** Variables **
  //  ***************
  const classes = useStyles();
  const timeoutVideoVisibility = useRef(null);

  const [isVisible, setIsVisible] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(!!document.fullscreenElement);
  const [videoClass, setVideoClass] = useState("");
  


  //  ****************
  //  ** Use Effect **
  //  ****************
  useEffect(() => {
    const handleFullScreen = () => setIsFullscreen(!!document.fullscreenElement);

    document.addEventListener("fullscreenchange", handleFullScreen);
    return () => document.removeEventListener("fullscreenchange", handleFullScreen);
  }, []);

  useEffect(() => {
    if (message.isDeleted && isFullscreen) {
      setVideoClass(`${classes.messageMediaFullScreen} ${classes.deletedMediaMessage}`);
      return;
    }
    
    if (message.isDeleted) {
      setVideoClass(`${classes.messageMedia} ${classes.deletedMediaMessage}`);
      return;
    }

    if (isFullscreen) {
      setVideoClass(classes.messageMediaFullScreen);
      return;
    }

    setVideoClass(classes.messageMedia);
  }, [classes, message, isFullscreen]);



  //  ***************
  //  ** Functions **
  //  ***************
  const handleViewOnceImageVisibility = () => { setIsVisible((prevValue) => !prevValue); };
  
  const handleViewOnceVideoVisibility = () => {
    setIsVisible((prevValue) => !prevValue);

    if (timeoutVideoVisibility.current) clearTimeout(timeoutVideoVisibility.current);

    timeoutVideoVisibility.current = setTimeout(() => {
      const video = document.getElementById(`viewOnceVideo-${message.id}`);
      if (!isVisible) video.play();
      else video.pause();
    }, 300);
  };



  //  ************
  //  ** Return **
  //  ************
  return (
    <div style={{position: "relative"}}>
      {/*
        *******************
        ** Spoiler Alert **
        *******************
      */}
      {!isVisible && (
        <span
          className={message.isDeleted ? `${classes.spoilerSpan} ${classes.deletedMediaSpoilerSpan}` : classes.spoilerSpan}
          onClick={() => {
            if (!isPhoto) handleViewOnceVideoVisibility();
            else handleViewOnceImageVisibility();
          }}
        >
          <TripOriginOutlined /> Spoiler
        </span>
      )}

      {/* 
        ************************
        ** Not Visible: Video **
        ************************
      */}
      {!isPhoto && videoRefs && (
        <video
          id={`viewOnceVideo-${message.id}`}
          key={`${refKey}-${message.updatedAt || ""}`}
          ref={element => videoRefs.current[refKey] = element}
          className={videoClass}
          src={message.mediaUrl}
          controls={isVisible}
          autoPlay={false}
          muted={false}
          loop={false}
          style={{ filter: !isVisible ? "blur(18px)" : "blur(0px)" }}
          onClick={handleViewOnceVideoVisibility}
        />
      )}

      {!isPhoto && !videoRefs && (
        <video
          id={`viewOnceVideo-${message.id}`}
          className={videoClass}
          src={message.mediaUrl}
          controls={isVisible}
          autoPlay={false}
          muted={false}
          loop={false}
          style={{ filter: !isVisible ? "blur(18px)" : "blur(0px)" }}
          onClick={handleViewOnceVideoVisibility}
        />
      )}



      {/* 
        ***********
        ** Image **
        ***********
      */}
      {isPhoto && (
        <img
          className={message.isDeleted ? `${classes.messageMedia} ${classes.deletedMediaMessage}` : classes.messageMedia}
          src={message.mediaUrl}
          alt={message.body}
          style={{ filter: !isVisible ? "blur(18px)" : "blur(0px)" }}
          onClick={handleViewOnceImageVisibility}
        />
      )}
    </div>
  );
};

export default ViewOnceMessage;